import { apiSlice } from "./apiSlice";

export const dmsSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => {
        return {
            getFolders: builder.query({
                query: ({ projectId, parentId, ...params }) => ({
                    url: `Folder/${projectId}/folders`,
                    params: { parentId, ...params }
                }),

            }),

            createFolder: builder.mutation({
                query: (body) => ({
                    url: `Folder/create-folder`,
                    method: "POST",
                    body
                }),

            }),

            uploadFile: builder.mutation({
                query: (formData) => ({
                    url: `File/upload`,
                    method: "POST",
                    body: formData,
                }),

            }),

            createFolderUploadJob: builder.mutation({
                query: (body) => ({
                    url: `File/folder-upload-jobs`,
                    method: "POST",
                    body,
                }),
            }),

            completeFolderUploadJob: builder.mutation({
                query: (jobId) => ({
                    url: `File/folder-upload-jobs/${jobId}/complete`,
                    method: "POST",
                }),
            }),

            getFolderUploadJob: builder.query({
                query: (jobId) => ({
                    url: `File/folder-upload-jobs/${jobId}`,
                    method: "GET",
                }),
            }),

            renameFolder: builder.mutation({
                query: (formData) => ({
                    url: `Folder/folders/rename`,
                    method: "PUT",
                    body: formData,
                }),

            }),

            downloadFile: builder.query({
                query: ({ fileId, ...params }) => ({
                    url: `File/${fileId}/download`,
                    method: 'GET',
                    params: params,
                    responseHandler: (response) => response.blob(),
                }),
            }),

            renameFile: builder.mutation({
                query: (formData) => ({
                    url: `File/files/rename`,
                    method: "PUT",
                    body: formData,
                }),

            }),
            getFilesByCustomId: builder.query({
                query: (customId) => ({
                    url: `File/${customId}`
                }),
            }),


            uploadModuleFile: builder.mutation({
                query: (formData) => {
                    return {
                        url: '/File/upload/module',
                        method: 'POST',
                        body: formData
                    };
                },
            }),

            permissionList: builder.query({
                query: () => {
                    return {
                        url: `/Permission/permissionlist`
                    }
                }
            }),

            shareFolderPermission: builder.mutation({
                query: ({ folderId, email, permissionType }) => {
                    return {
                        url: `/Permission/folders/${folderId}`,
                        method: 'POST',
                        body: {
                            email,
                            permissionType
                        }

                    }
                }
            }),

            shareFilePermission: builder.mutation({
                query: ({ fileId, email, permissionType }) => {
                    return {
                        url: `/Permission/files/${fileId}`,
                        method: 'POST',
                        body: {
                            email,
                            permissionType
                        }

                    }
                }
            }),

            deletePermission: builder.mutation(({
                query: ({ permissionId, type }) => {
                    return {
                        url: `/Permission/${permissionId}`,
                        method: 'DELETE',
                        params: { type },
                        // body: {
                        //     permissionId,
                        //     type
                        // }
                    }
                }
            })),

            getFileComments: builder.query({
                query: (fileId) => ({
                    url: `File/${fileId}/comments`,
                    method: 'GET'
                }),
                providesTags: ["FileComments"]
            }),

            addCommentOnFile: builder.mutation({
                query: (payload) => ({
                    url: "File/addfilecomments",
                    method: "POST",
                    body: payload
                }),
                invalidatesTags: ["FileComments"]
            }),

            uploadFileVersion: builder.mutation({
                query: (formData) => ({
                    url: `File/fileversionupload`,
                    method: "POST",
                    body: formData,
                }),
            }),

            deleteFolder: builder.mutation({
                query: (folderId) => ({
                    url: `Folder/${folderId}`,
                    method: "DELETE",
                }),
            }),

            deleteFile: builder.mutation({
                query: (fileId) => ({
                    url: `File/${fileId}`,
                    method: "DELETE",
                }),
            })
        }
    }
})


export const {
    useGetFoldersQuery,
    useLazyGetFoldersQuery,
    useCreateFolderMutation,
    useUploadFileMutation,
    useCreateFolderUploadJobMutation,
    useCompleteFolderUploadJobMutation,
    useLazyGetFolderUploadJobQuery,
    useRenameFolderMutation,
    useLazyDownloadFileQuery,
    useRenameFileMutation,
    useGetFilesByCustomIdQuery,
    useUploadModuleFileMutation,
    usePermissionListQuery,
    useShareFolderPermissionMutation,
    useShareFilePermissionMutation,
    useDeletePermissionMutation,
    useGetFileCommentsQuery,
    useAddCommentOnFileMutation,
    useUploadFileVersionMutation,
    useDeleteFolderMutation,
    useDeleteFileMutation
} = dmsSlice
